import {CardDefinition} from '../../../common/types'
import {elementKeyToUrlPath} from '../state/helpers'

/**
 * Fill in missing keys in the card definition
 * I want these to be predictable and unique, so that if two users use this definition, they have the same keys generated
 */
export const addMissingKeys = (
  cardDefinition: CardDefinition
): CardDefinition => {
  // Helper function is only called in the event that we need to generate a unique key
  const ensureUnique = (key: string, attempt?: number): string => {
    const elementKey = `${key}${attempt ? `-${attempt}` : ''}`
    const [, foundDuplicate] =
      elementKeyToUrlPath(cardDefinition, elementKey) ?? []
    if (foundDuplicate) {
      // try again with an incremented key
      return ensureUnique(key, attempt ? attempt + 1 : 1)
    }
    return elementKey
  }

  return {
    ...cardDefinition,
    defaultView: {
      ...cardDefinition.defaultView,
      content: cardDefinition.defaultView.content.map((n, i) => ({
        ...n,
        key: n.key ?? ensureUnique(`${n.type}-dfc${i}`)
      })),
      actions: cardDefinition.defaultView.actions.map((n, i) => ({
        ...n,
        key: n.key ?? ensureUnique(`${n.type}-dfa${i}`)
      }))
    },
    subviews: Object.fromEntries(
      Object.entries(cardDefinition.subviews).map(([id, subview]) => [
        id,
        {
          ...subview,
          inputs: subview.inputs.map((n, i) => ({
            ...n,
            key: n.key ?? ensureUnique(`${n.type}-si${i}`)
          })),
          actions: subview.actions.map((n, i) => ({
            ...n,
            key: n.key ?? ensureUnique(`${n.type}-sa${i}`)
          }))
        }
      ])
    )
  }
}
